<div class="project-profile-page">
  <button
    type="button"
    class="page-back-btn"
    (click)="goBackToFeed()"
    [attr.aria-label]="'socialFeed.back' | transloco"
  >
    <i class="pi pi-arrow-left"></i>
    <span>{{ "socialFeed.back" | transloco }}</span>
  </button>

  <div class="project-notfound" *ngIf="notFound">
    <i class="pi pi-lock"></i>
    <p>{{ 'shareProject.notFound' | transloco }}</p>
    <p-button
      [label]="'shareProject.anonLogin' | transloco"
      severity="danger"
      (onClick)="router.navigate(['/login'])"
    />
  </div>

  <div class="project-needlogin" *ngIf="needsLogin">
    <i class="pi pi-lock"></i>
    <p>{{ 'shareProject.loginRequired' | transloco }}</p>
    <div class="project-needlogin__actions">
      <p-button [label]="'shareProject.login' | transloco" severity="danger" (onClick)="goLoginReturn()" />
      <p-button [label]="'shareProject.createAccount' | transloco" [outlined]="true" severity="danger" (onClick)="goCreateAccount()" />
    </div>
  </div>

  <div *ngIf="loading && !notFound && !needsLogin" class="loading-center">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <ng-container *ngIf="!loading && !notFound && !needsLogin && profile">
    <header class="project-header">
      <div class="project-cover">
        <img
          *ngIf="projectAvatarTransformedUrl && !projectAvatarLoadError"
          [src]="projectAvatarTransformedUrl"
          [alt]="profile.projectName"
          (error)="projectAvatarLoadError = true"
        />
        <div *ngIf="!projectAvatarTransformedUrl || projectAvatarLoadError" class="project-cover-placeholder">
          <i class="pi pi-car"></i>
        </div>
      </div>

      <div class="project-info">
        <div class="project-title-row">
          <h1>{{ profile.projectName }}</h1>
          <div class="project-kebab" #projectKebab>
            <button
              class="ig-card__more"
              (click)="showProjectActions = !showProjectActions"
              type="button"
              aria-label="Ações do projeto"
            >
              <i class="pi pi-ellipsis-v"></i>
            </button>
            <div class="ig-card__dropdown" *ngIf="showProjectActions">
              <button type="button" (click)="openShare()">{{ 'shareProject.share' | transloco }}</button>
              <button
                type="button"
                *ngIf="profile.isOwnedByViewer"
                (click)="openVisibility()"
              >{{ 'shareProject.adjustVisibility' | transloco }}</button>
              <!-- Denúncia e bloqueio são sempre da PESSOA (dono do projeto), nunca do projeto. -->
              <button
                type="button"
                *ngIf="!profile.isOwnedByViewer && currentUserId"
                (click)="reportOwner()"
              >{{ 'socialFeed.reportUserNamed' | transloco: { name: ownerDisplay } }}</button>
              <button
                type="button"
                *ngIf="!profile.isOwnedByViewer && currentUserId"
                (click)="blockOwner()"
              >{{ 'socialFeed.blockUserNamed' | transloco: { name: ownerDisplay } }}</button>
            </div>
          </div>
          <app-social-report-dialog #reportDialog></app-social-report-dialog>
          <app-social-block-dialog #blockDialog (blocked)="onOwnerBlocked()"></app-social-block-dialog>
        </div>

        <p class="project-vehicle" *ngIf="vehicleLabel">
          {{ vehicleLabel }}
          <span *ngIf="profile.vehicleYear"> · {{ profile.vehicleYear }}</span>
        </p>

        <p class="project-bio" *ngIf="profile.bio">{{ profile.bio }}</p>

        <div class="project-meta">
          <span>
            <strong>{{ profile.postsCount }}</strong>
            {{ "socialFeed.tabPosts" | transloco }}
          </span>
          <button
            class="meta-followers"
            [class.is-clickable]="profile.followersCount > 0"
            [disabled]="!profile.followersCount"
            (click)="showFollowers()"
            type="button"
          >
            <strong>{{ profile.followersCount }}</strong>
            {{ "socialFeed.followersTitle" | transloco }}
          </button>
          <button class="owner-link" (click)="goToOwnerProfile()" type="button">
            <img
              *ngIf="ownerAvatarTransformedUrl && !ownerAvatarLoadError"
              [src]="ownerAvatarTransformedUrl"
              alt=""
              class="owner-avatar-img"
              (error)="ownerAvatarLoadError = true"
            />
            <span class="owner-avatar-fallback" *ngIf="!ownerAvatarTransformedUrl || ownerAvatarLoadError">
              {{ ownerInitial }}
            </span>
            <span class="owner-name">{{ ownerDisplay }}</span>
          </button>
        </div>

        <div class="project-actions" *ngIf="!isAnonymous">
          <button
            *ngIf="profile.isOwnedByViewer && canPublish"
            class="btn-publish"
            (click)="goCreatePost()"
            type="button"
          >
            <i class="pi pi-plus"></i>
            {{ "socialFeed.publish" | transloco }}
          </button>

          <button
            *ngIf="!profile.isOwnedByViewer"
            class="btn-follow"
            [class.following]="profile.isFollowedByViewer"
            [disabled]="followBusy"
            (click)="toggleFollow()"
            type="button"
          >
            <i
              class="pi"
              [class.pi-user-plus]="!profile.isFollowedByViewer"
              [class.pi-check]="profile.isFollowedByViewer"
            ></i>
            {{
              (profile.isFollowedByViewer
                ? "socialFeed.following"
                : "socialFeed.follow"
              ) | transloco
            }}
          </button>
        </div>

        <div class="anon-cta" *ngIf="isAnonymous && !notFound">
          <span>{{ 'shareProject.anonCta' | transloco }}</span>
          <p-button
            [label]="'shareProject.anonLogin' | transloco"
            severity="danger"
            (onClick)="router.navigate(['/login'])"
          />
        </div>
      </div>
    </header>

    <!-- TABS -->
    <nav class="project-tabs">
      <button
        type="button"
        class="project-tab"
        [class.active]="activeTab === 'posts'"
        (click)="switchTab('posts')"
      >
        <i class="pi pi-th-large"></i>
        {{ "socialFeed.tabPosts" | transloco }}
      </button>
      <button
        type="button"
        class="project-tab"
        [class.active]="activeTab === 'info'"
        (click)="switchTab('info')"
      >
        <i class="pi pi-info-circle"></i>
        {{ "projectProfile.infoTab" | transloco }}
      </button>
    </nav>

    <!-- POSTS TAB -->
    <section class="project-posts" *ngIf="activeTab === 'posts'">
      <div *ngIf="!posts.length && !postsLoading" class="empty-state">
        <i class="pi pi-inbox"></i>
        <p>{{ "socialFeed.noPosts" | transloco }}</p>
      </div>

      <app-social-post-card
        *ngFor="let post of posts"
        [post]="post"
        [currentUserId]="currentUserId"
        [currentUserAvatarUrl]="currentUserAvatarUrl"
        [followedProjectIds]="postCardFollowedSet"
        (postChanged)="onPostChanged()"
      ></app-social-post-card>

      <div *ngIf="postsLoading" class="loading-row">
        <p-progressSpinner styleClass="small-spinner"></p-progressSpinner>
      </div>

      <div #postSentinel class="post-sentinel" *ngIf="postsCursor && !postsLoading"></div>
    </section>

    <!-- INFO TAB -->
    <section class="project-info-tab" *ngIf="activeTab === 'info'">
      <!-- VEHICLE DATA -->
      <div class="info-section">
        <h3 class="info-section-title">
          <i class="pi pi-car"></i>
          {{ "projectProfile.vehicleData" | transloco }}
        </h3>
        <div class="info-grid">
          <div class="info-card">
            <div class="info-card-icon"><i class="pi pi-building"></i></div>
            <div class="info-card-label">{{ "projectProfile.manufacturer" | transloco }}</div>
            <div class="info-card-value">{{ profile.vehicleManufacturer || '—' }}</div>
          </div>
          <div class="info-card">
            <div class="info-card-icon"><i class="pi pi-car"></i></div>
            <div class="info-card-label">{{ "projectProfile.model" | transloco }}</div>
            <div class="info-card-value">{{ profile.vehicleModel || '—' }}</div>
          </div>
          <div class="info-card">
            <div class="info-card-icon"><i class="pi pi-calendar"></i></div>
            <div class="info-card-label">{{ "projectProfile.year" | transloco }}</div>
            <div class="info-card-value">{{ profile.vehicleYear || '—' }}</div>
          </div>
        </div>
      </div>

      <!-- VCUs -->
      <div class="info-section" *ngIf="profile.vcus.length">
        <h3 class="info-section-title">
          <i class="pi pi-microchip"></i>
          {{ "projectProfile.vcus" | transloco }}
        </h3>
        <div class="vcu-grid">
          <div class="vcu-card" *ngFor="let v of profile.vcus" [class.inactive]="!v.active">
            <div class="vcu-card-header">
              <span class="vcu-card-label">VCU</span>
              <span class="vcu-status" [class.is-active]="v.active">
                <span class="vcu-status-dot"></span>
                {{ (v.active ? 'projectProfile.vcuActive' : 'projectProfile.vcuInactive') | transloco }}
              </span>
            </div>
            <div class="vcu-card-name">{{ v.nickname || ('projectProfile.unnamedVcu' | transloco) }}</div>
            <div class="vcu-card-meta" *ngIf="v.serialNumber">
              <span class="vcu-meta-label">{{ "projectProfile.serialNumber" | transloco }}:</span>
              {{ v.serialNumber }}
            </div>
            <div class="vcu-card-meta" *ngIf="v.familyId !== null && v.familyId !== undefined">
              <span class="vcu-meta-label">{{ "projectProfile.family" | transloco }}:</span>
              {{ vcuFamilyLabel(v.familyId) }}
            </div>
          </div>
        </div>
      </div>

      <!-- ADDITIONAL ATTRIBUTES (custom) -->
      <div class="info-section" *ngIf="specsAttributeKeys.length">
        <h3 class="info-section-title">
          <i class="pi pi-list"></i>
          {{ "projectProfile.additionalSpecs" | transloco }}
        </h3>
        <dl class="attribute-list">
          <ng-container *ngFor="let key of specsAttributeKeys">
            <dt>{{ key }}</dt>
            <dd>{{ profile.attributes[key] }}</dd>
          </ng-container>
        </dl>
      </div>

      <!-- DETAIL TEXT -->
      <div class="info-section" *ngIf="profile.bio">
        <h3 class="info-section-title">
          <i class="pi pi-align-left"></i>
          {{ "projectProfile.description" | transloco }}
        </h3>
        <p class="info-detail-text">{{ profile.bio }}</p>
      </div>
    </section>
  </ng-container>

  <p-toast key="toastAccount"></p-toast>

  <!-- FOLLOWERS DIALOG -->
  <p-dialog
    [(visible)]="followersDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [header]="'socialFeed.followersTitle' | transloco"
    [style]="{ width: 'min(420px, 95vw)' }"
    styleClass="ig-followers-dialog"
  >
    <div class="ig-followers-list">
      <div *ngIf="followersListLoading" class="ig-followers-list__loading">
        <p-progressSpinner [style]="{ width: '28px', height: '28px' }"></p-progressSpinner>
      </div>

      <button
        *ngFor="let u of followersList"
        type="button"
        class="ig-followers-list__item"
        (click)="goToFollowerProfile(u.userId)"
      >
        <span class="ig-followers-list__avatar">
          {{ followerDisplay(u).charAt(0).toUpperCase() }}
        </span>
        <span class="ig-followers-list__name">{{ followerDisplay(u) }}</span>
      </button>

      <p
        class="ig-followers-list__empty"
        *ngIf="!followersListLoading && !followersList.length"
      >
        {{ "socialFeed.noFollowers" | transloco }}
      </p>
    </div>
  </p-dialog>

  <!-- SHARE PROJECT MODAL -->
  <app-share-project-modal
    *ngIf="profile"
    [projectId]="projectId"
    [ownerUserId]="profile.ownerUserId"
    [sharingTypeId]="profile.sharingProjectTypeId || 0"
    [isOwner]="profile.isOwnedByViewer"
    [(visible)]="showShareModal"
    (sharingTypeChanged)="profile.sharingProjectTypeId = $event"
  ></app-share-project-modal>

  <!-- ADJUST VISIBILITY DIALOG (owner) -->
  <p-dialog
    *ngIf="profile"
    [header]="'shareProject.visibilityTitle' | transloco"
    [modal]="true"
    [(visible)]="showVisibilityDialog"
    [style]="{ width: '90vw', maxWidth: '380px' }"
  >
    <div class="visibility-options">
      <button
        type="button"
        class="visibility-option"
        [class.selected]="profile.sharingProjectTypeId === 1"
        [disabled]="savingVisibility"
        (click)="setProjectVisibility(1)"
      >
        <strong>{{ 'shareProject.visPublic' | transloco }}</strong>
        <small>{{ 'shareProject.visPublicHint' | transloco }}</small>
      </button>
      <button
        type="button"
        class="visibility-option"
        [class.selected]="profile.sharingProjectTypeId === 2"
        [disabled]="savingVisibility"
        (click)="setProjectVisibility(2)"
      >
        <strong>{{ 'shareProject.visLink' | transloco }}</strong>
        <small>{{ 'shareProject.visLinkHint' | transloco }}</small>
      </button>
      <button
        type="button"
        class="visibility-option"
        [class.selected]="profile.sharingProjectTypeId === 3"
        [disabled]="savingVisibility"
        (click)="setProjectVisibility(3)"
      >
        <strong>{{ 'shareProject.visPrivate' | transloco }}</strong>
        <small>{{ 'shareProject.visPrivateHint' | transloco }}</small>
      </button>
    </div>
  </p-dialog>
</div>
